<template>
<div  class="qrCode">
      <div class="qrCode_inner clearfix">
        <div class="qrCode_rg">
          <div class="qrCode_li">
            <div class="qrCode_li_lf wow fadeInUp">
                <img src="~@/assets/image/eq_ico1.jpg" class="eq_ico1" />
            </div>
            <div class="qrCode_li_rg">
              <p class="qrCode_li_p1 wow fadeInUp">下载菱势汽车APP</p>
              <p class="qrCode_li_p2 wow fadeInUp">加入菱势大家庭<br>引领汽车新势力</p>
            </div>
          </div>
          <div class="qrCode_li">
            <div class="qrCode_li_lf wow fadeInUp">
                <img src="~@/assets/image/eq_ico2.png" class="eq_ico1" />
            </div>
            <div class="qrCode_li_rg">
              <p class="qrCode_li_p1 wow fadeInUp">关注菱势汽车抖音号</p>
              <p class="qrCode_li_p2 wow fadeInUp">发现更多新鲜资讯<br>官方花样互动“菱”距离</p>
            </div>
          </div>
          <div class="qrCode_li">
            <div class="qrCode_li_lf wow fadeInUp">
                <img src="~@/assets/image/eq_ico3.jpg" class="eq_ico1" />
            </div>
            <div class="qrCode_li_rg">
              <p class="qrCode_li_p1 wow fadeInUp">关注菱势汽车公众号</p>
              <p class="qrCode_li_p2 wow fadeInUp">最新最全资讯一手掌握<br>享受丰厚购车优惠</p>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
  export default {
    data () {
      return {


      }
    },
    created () {
    },

    mounted () {
// 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()
    })
    },
    methods: {


    },
  }
</script>


// WEBPACK FOOTER //
// src/components/home/qrcode.vue